import React from 'react'

const MedicationNameToolTip = ({name, manufacturer}) => {
  return (
    <div className='bg-gray-20 p-2 max-w-md flex flex-col'>
        <p className="text-teal-300 text-left text-body-sm font-normal">
        {name}
        </p>
        {manufacturer && (
          <p className="text-teal-300 text-left text-body-sm font-normal">
            {manufacturer}
          </p>
        )}
    </div>
  )
}

export default MedicationNameToolTip